// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes agce-wallet-ov-sk-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.agce-wallet-ov-sk__bone {
  display: inline-block;
  border-radius: 8px;
  background: linear-gradient(
    100deg,
    rgba(148, 163, 184, 0.16) 0%,
    rgba(148, 163, 184, 0.38) 40%,
    rgba(148, 163, 184, 0.16) 80%
  );
  background-size: 220% 100%;
  animation: agce-wallet-ov-sk-shimmer 1.35s ease-in-out infinite;
  vertical-align: middle;
}

body.light_theme .agce-wallet-ov-sk__bone {
  background: linear-gradient(
    100deg,
    rgba(148, 163, 184, 0.2) 0%,
    rgba(148, 163, 184, 0.45) 45%,
    rgba(148, 163, 184, 0.2) 90%
  );
  background-size: 220% 100%;
}

.agce-wallet-ov-sk {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.agce-wallet-ov-sk__header-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
}

.agce-wallet-ov-sk__title-bar {
  width: min(260px, 55%);
  height: 28px;
  border-radius: 10px;
}

.agce-wallet-ov-sk__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.agce-wallet-ov-sk__btn-sm {
  width: 112px;
  height: 40px;
  border-radius: 10px;
}

.agce-wallet-ov-sk__estimated {
  margin-bottom: 20px;
  padding-bottom: 4px;
}

.agce-wallet-ov-sk__est-label {
  width: 120px;
  height: 13px;
  margin-bottom: 14px;
  border-radius: 6px;
}

.agce-wallet-ov-sk__est-line-lg {
  display: block;
  width: min(340px, 88%);
  height: 34px;
  margin-bottom: 10px;
  border-radius: 10px;
}

.agce-wallet-ov-sk__est-line-sm {
  display: block;
  width: min(420px, 92%);
  height: 16px;
  border-radius: 8px;
}

.agce-wallet-ov-sk__tabs-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.agce-wallet-ov-sk__tabs {
  display: flex;
  gap: 10px;
}

.agce-wallet-ov-sk__tab-chip {
  width: 104px;
  height: 36px;
  border-radius: 10px;
}

.agce-wallet-ov-sk__toolbar-tools {
  display: flex;
  align-items: center;
  gap: 14px;
}

.agce-wallet-ov-sk__search-chip {
  width: 200px;
  height: 40px;
  border-radius: 10px;
}

.agce-wallet-ov-sk__check-chip {
  width: 120px;
  height: 20px;
  border-radius: 6px;
}

.agce-wallet-ov-sk .funding-account__toprow ~ .agce-wallet-ov-sk__filters-strip {
  margin-top: -4px;
}

.agce-wallet-ov-sk__filters-strip {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.agce-wallet-ov-sk__search-wide {
  width: min(360px, 100%);
  height: 40px;
  border-radius: 10px;
}

.agce-wallet-ov-sk__check-wide {
  width: 134px;
  height: 20px;
  border-radius: 6px;
}

.agce-wallet-ov-sk__hintbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding: 12px 0;
}

.agce-wallet-ov-sk__hint-line {
  flex: 1 1;
  height: 14px;
  max-width: 520px;
  border-radius: 6px;
}

.agce-wallet-ov-sk__tablewrap.table-responsive {
  overflow: visible;
}

.agce-wallet-ov-sk__table thead th {
  border-bottom: none;
}

.agce-wallet-ov-sk__coin {
  display: flex;
  align-items: center;
  gap: 12px;
}

.agce-wallet-ov-sk__coin-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  flex-shrink: 0;
}

.agce-wallet-ov-sk__coin-lines {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.agce-wallet-ov-sk__coin-line-a {
  width: 76px;
  height: 15px;
  border-radius: 6px;
}

.agce-wallet-ov-sk__coin-line-b {
  width: 120px;
  height: 12px;
  border-radius: 6px;
}

.agce-wallet-ov-sk__cell-num {
  display: inline-block;
  margin-left: auto;
  height: 16px;
  border-radius: 6px;
}

.agce-wallet-ov-sk__cell-num--w52 {
  width: 54px;
}
.agce-wallet-ov-sk__cell-num--w72 {
  width: 72px;
}
.agce-wallet-ov-sk__cell-num--w80 {
  width: 92px;
}
.agce-wallet-ov-sk__pill {
  width: 52px;
  height: 28px;
  border-radius: 8px;
}

.agce-wallet-ov-sk__pill-action {
  display: inline-block;
  width: 96px;
  height: 40px;
  border-radius: 999px;
}
`, "",{"version":3,"sources":["webpack://./src/customComponents/WalletOverviewSkeleton/walletOverviewSkeleton.css"],"names":[],"mappings":"AAAA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB;;;;;GAKC;EACD,0BAA0B;EAC1B,+DAA+D;EAC/D,sBAAsB;AACxB;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB","sourcesContent":["@keyframes agce-wallet-ov-sk-shimmer {\n  0% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n.agce-wallet-ov-sk__bone {\n  display: inline-block;\n  border-radius: 8px;\n  background: linear-gradient(\n    100deg,\n    rgba(148, 163, 184, 0.16) 0%,\n    rgba(148, 163, 184, 0.38) 40%,\n    rgba(148, 163, 184, 0.16) 80%\n  );\n  background-size: 220% 100%;\n  animation: agce-wallet-ov-sk-shimmer 1.35s ease-in-out infinite;\n  vertical-align: middle;\n}\n\nbody.light_theme .agce-wallet-ov-sk__bone {\n  background: linear-gradient(\n    100deg,\n    rgba(148, 163, 184, 0.2) 0%,\n    rgba(148, 163, 184, 0.45) 45%,\n    rgba(148, 163, 184, 0.2) 90%\n  );\n  background-size: 220% 100%;\n}\n\n.agce-wallet-ov-sk {\n  pointer-events: none;\n  user-select: none;\n}\n\n.agce-wallet-ov-sk__header-row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.agce-wallet-ov-sk__title-bar {\n  width: min(260px, 55%);\n  height: 28px;\n  border-radius: 10px;\n}\n\n.agce-wallet-ov-sk__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.agce-wallet-ov-sk__btn-sm {\n  width: 112px;\n  height: 40px;\n  border-radius: 10px;\n}\n\n.agce-wallet-ov-sk__estimated {\n  margin-bottom: 20px;\n  padding-bottom: 4px;\n}\n\n.agce-wallet-ov-sk__est-label {\n  width: 120px;\n  height: 13px;\n  margin-bottom: 14px;\n  border-radius: 6px;\n}\n\n.agce-wallet-ov-sk__est-line-lg {\n  display: block;\n  width: min(340px, 88%);\n  height: 34px;\n  margin-bottom: 10px;\n  border-radius: 10px;\n}\n\n.agce-wallet-ov-sk__est-line-sm {\n  display: block;\n  width: min(420px, 92%);\n  height: 16px;\n  border-radius: 8px;\n}\n\n.agce-wallet-ov-sk__tabs-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.agce-wallet-ov-sk__tabs {\n  display: flex;\n  gap: 10px;\n}\n\n.agce-wallet-ov-sk__tab-chip {\n  width: 104px;\n  height: 36px;\n  border-radius: 10px;\n}\n\n.agce-wallet-ov-sk__toolbar-tools {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.agce-wallet-ov-sk__search-chip {\n  width: 200px;\n  height: 40px;\n  border-radius: 10px;\n}\n\n.agce-wallet-ov-sk__check-chip {\n  width: 120px;\n  height: 20px;\n  border-radius: 6px;\n}\n\n.agce-wallet-ov-sk .funding-account__toprow ~ .agce-wallet-ov-sk__filters-strip {\n  margin-top: -4px;\n}\n\n.agce-wallet-ov-sk__filters-strip {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.agce-wallet-ov-sk__search-wide {\n  width: min(360px, 100%);\n  height: 40px;\n  border-radius: 10px;\n}\n\n.agce-wallet-ov-sk__check-wide {\n  width: 134px;\n  height: 20px;\n  border-radius: 6px;\n}\n\n.agce-wallet-ov-sk__hintbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n  padding: 12px 0;\n}\n\n.agce-wallet-ov-sk__hint-line {\n  flex: 1;\n  height: 14px;\n  max-width: 520px;\n  border-radius: 6px;\n}\n\n.agce-wallet-ov-sk__tablewrap.table-responsive {\n  overflow: visible;\n}\n\n.agce-wallet-ov-sk__table thead th {\n  border-bottom: none;\n}\n\n.agce-wallet-ov-sk__coin {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.agce-wallet-ov-sk__coin-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.agce-wallet-ov-sk__coin-lines {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.agce-wallet-ov-sk__coin-line-a {\n  width: 76px;\n  height: 15px;\n  border-radius: 6px;\n}\n\n.agce-wallet-ov-sk__coin-line-b {\n  width: 120px;\n  height: 12px;\n  border-radius: 6px;\n}\n\n.agce-wallet-ov-sk__cell-num {\n  display: inline-block;\n  margin-left: auto;\n  height: 16px;\n  border-radius: 6px;\n}\n\n.agce-wallet-ov-sk__cell-num--w52 {\n  width: 54px;\n}\n.agce-wallet-ov-sk__cell-num--w72 {\n  width: 72px;\n}\n.agce-wallet-ov-sk__cell-num--w80 {\n  width: 92px;\n}\n.agce-wallet-ov-sk__pill {\n  width: 52px;\n  height: 28px;\n  border-radius: 8px;\n}\n\n.agce-wallet-ov-sk__pill-action {\n  display: inline-block;\n  width: 96px;\n  height: 40px;\n  border-radius: 999px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
